import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { Projecttemplate } from './model/projecttemplate';
import { ProjecttemplatecreateService } from './service/projecttemplatecreate.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalService } from '@src/app/helpers/modal.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projecttemplatecreate',
  templateUrl: './projecttemplatecreate.component.html',
  styleUrls: ['./projecttemplatecreate.component.css']
})
export class ProjecttemplatecreateComponent implements OnInit, OnChanges {
  @ViewChild('closeconfirm',{static:true}) closeconfirm:ElementRef;
  @Input() project:Project;
  @Input() list:boolean;
  ptemplate:Projecttemplate;
  errorMessage:string;
  updateMessage:string;
  loader:boolean = false;
  constructor(
    private ptc:ProjecttemplatecreateService,
    private modalservice:ModalService
  ) { }

  ngOnChanges(changes : SimpleChanges) {
    if(changes.project.currentValue != changes.project.previousValue){
      this.project = changes.project.currentValue;
      this.ptemplate = {
        title: this.project.title,
        templatedescription: this.project.shortdescription,
        templateId: 'no id created yet',
        projectId: this.project.projectId,
        templatestate: 'in process',
        created: new Date(),
        creator: SessionHelper.getUserSub(),
        recipe: JSON.stringify(this.project),
        organizationId: SessionHelper.getChoosenOrg(),
  
      }
    }
    
  }
  ngOnInit() {
    this.ptemplate = new Projecttemplate();
    this.ptemplate = {
      title: this.project.title,
      templatedescription: this.project.shortdescription,
      templateId: 'no id created yet',
      projectId: this.project.projectId,
      templatestate: 'in process',
      created: new Date(),
      creator: SessionHelper.getUserSub(),
      recipe: JSON.stringify(this.project),
      organizationId: SessionHelper.getChoosenOrg(),

    }
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.project && changes.project.currentValue) {
  //     this.ptemplate = {
  //       title: this.project.title,
  //       templatedescription: this.project.shortdescription,
  //       templateId: 'no id created yet',
  //       projectId: this.project.projectId,
  //       templatestate: 'in process',
  //       created: new Date(),
  //       creator: SessionHelper.getUserSub(),
  //       recipe: JSON.stringify(this.project),
  //       organizationId: this.project.organizationId
  //     }
  //   }
  // }
  createTemplate(){
    if(!this.project.title  || !this.project.projectdescription){
      this.errorMessage = "modalvalidation.requiredfieldmissing";
    }else{
      this.loader = true;
    this.ptc.createTemplate(this.ptemplate).pipe(untilDestroyed(this)).subscribe(result => {
      this.ptemplate.templateId = result;
      this.closeModal();
      this.loader = false;
    });}
  }
  closeModal(){
    this.project = null;
    this.modalservice.close('projectTemplateModal');
  }
}
